import { render, staticRenderFns } from "./add.vue?vue&type=template&id=1b0d70ba&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=1b0d70ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0d70ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b0d70ba')) {
      api.createRecord('1b0d70ba', component.options)
    } else {
      api.reload('1b0d70ba', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=1b0d70ba&scoped=true&", function () {
      api.rerender('1b0d70ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apply/shop/add.vue"
export default component.exports